import { Typography } from 'antd';
import { BulbOutlined } from '@ant-design/icons';

const { Text } = Typography;

export interface AIPromptCardProps {
  title: string;
  subtitle?: string;
  onClick: () => void;
}

export function AIPromptCard({ title, subtitle, onClick }: AIPromptCardProps) {
  return (
    <div
      className="ai-prompt-card"
      role="button"
      tabIndex={0}
      aria-label={title}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <BulbOutlined style={{ fontSize: 20, color: '#1677ff', marginRight: 14, flexShrink: 0 }} />
      <div>
        <Text strong style={{ display: 'block', fontSize: 14 }}>
          {title}
        </Text>
        {subtitle ? (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {subtitle}
          </Text>
        ) : null}
      </div>
    </div>
  );
}
